<template>
    <div id="homeAppSum">
        <a-card title="应用统计">
            <msearch @searchChange="handleSearchChange" ref="appSumSearchT"  :onlyFlow="onlyFlow"></msearch>
            <mtable :searchD="searchD" :onlyFlow="onlyFlow" @handleUrlSelected="handleTableSelected"  :style="{width:tableWidth}"></mtable>
            
        </a-card>

    </div>
</template>

<script>

import mtable from "./table"
import msearch from "./search"
export default {
    data(){
        return {
            searchD:{startTime:"",endTime:"",selectedAppcode:"",selectedType:"",selectedInvokeappcode:"",searchTimeRange:"",dateTypeTitle:''},
            onlyFlow:1,
            tableWidth:'800px'
        }
    },
    methods:{
        handleTableSelected(url_){
            this.$refs.appSumSearchT.setDefaultUrl(url_)
        },
        handleSearchChange(d){
            this.searchD = d;
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
    components:{
        mtable,
        msearch
    }
};
</script>

<style lang="less" scoped>
</style>
<style>
  #homeAppSum .ant-card-body{
        padding-top: 0;
    }
</style>